"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("./styles");
const LinkButton = props => {
  const {
    children,
    onClick,
    isDisabled,
    size = 'md',
    dataAutomation = 'button'
  } = props;
  const handleOnClick = e => {
    if (isDisabled) {
      return;
    }
    onClick(e);
  };
  return (0, jsx_runtime_1.jsx)(styles_1.StyledTextButton, {
    isDisabled: isDisabled,
    size: size,
    onClick: handleOnClick,
    "data-automation": dataAutomation,
    children: children
  });
};
exports.default = LinkButton;